import React from "react";
import { faStickyNote, faImages } from "@fortawesome/free-solid-svg-icons";
import { WithIcon } from "shared/table-helpers";
import MeasuringNoteButton from "./measuring-notes/measuring-notes-btn";
import { Checkbox } from "../../form-inputs/inputs/checkbox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

export const columns = (shipmentKey, products, selectedUpcs, setSelectedUpcs, updateSelectedUpcs, upcsWithMeasurements) => {
    return [
        {
            Header: () => {
                const value = selectedUpcs.length === products.length;
                const allProducts = products.map((p) => {
                    return {
                        isRedo: p.state === "redo",
                        ...p.context,
                    };
                });

                return (
                    <Checkbox
                        name="selected-state"
                        value={value}
                        onChange={() => setSelectedUpcs(value ? [] : allProducts)}
                    />
                );
            },
            accessor: "context.key",
            filterable: false,
            sortable: false,
            Cell: (row) => {
                const upcWithModifier = row.original.context.productModifier
                    ? `${row.original.context.upc}-${row.original.context.productModifier}`
                    : row.original.context.upc;
                const isRedo = row.original.state === "redo";
                const selectedObject = {
                    isRedo: isRedo,
                    ...row.original.context,
                };

                return (
                    <Checkbox
                        name={`select_${upcWithModifier}`}
                        value={selectedUpcs.some(
                            (select) => select.upc === row.original.context.upc && select.productModifier === row.original.context.productModifier
                        )}
                        onChange={(e) => updateSelectedUpcs(selectedObject, e.currentTarget.value)}
                        onClick={(e) => e.stopPropagation()}
                    />
                );
            },
            width: 65,
            className: "txt-center",
        },
        {
            id: "upc",
            Header: "UPC-Modifier",
            accessor: "context.upc",
            Cell: (row) => {
                const cssClass = !row.original.context.isUpcValid || row.original.state === "redo" ? "txt-error-light" : "";
                const title = !row.original.context.isUpcValid ? "Improper Upc" : "";
                const text = row.original.context.productModifier ? `${row.value}-${row.original.context.productModifier}` : row.value;

                return (
                    <span
                        className={cssClass}
                        title={title}
                    >
                        {text}
                    </span>
                );
            },
        },
        {
            Header: "Bin",
            accessor: "context.binTrackingNumber",
        },
        {
            Header: "Package Level",
            accessor: "context.packageLevelName",
            Cell: (row) => {
                return row.value ? row.value : "";
            },
        },
        {
            Header: "Task Status",
            accessor: "state",
            Cell: (row) => {
                let state = row.original.state;

                if (
                    upcsWithMeasurements.find(
                        (m) =>
                            m.upc === row.original.context.upc && m.productModifier === row.original.context.productModifier && state === "completed"
                    )
                ) {
                    return <span style={{ color: "#36b37e" }}>Completed</span>;
                } else if (
                    upcsWithMeasurements.find(
                        (m) =>
                            m.upc === row.original.context.upc &&
                            m.productModifier === row.original.context.productModifier &&
                            state === "in-progress"
                    )
                ) {
                    return <span className="txt-error-light">In Progress</span>;
                } else if (
                    upcsWithMeasurements.find(
                        (m) => m.upc === row.original.context.upc && m.productModifier === row.original.context.productModifier && state === "redo"
                    )
                ) {
                    return <span className="txt-error-light">Redo</span>;
                } else if (
                    upcsWithMeasurements.find((m) => m.upc === row.original.context.upc && m.productModifier === row.original.context.productModifier)
                ) {
                    return <span className="txt-error-light">In Progress</span>;
                } else {
                    return <span className="txt-error-light">Open</span>;
                }
            },
        },
        {
            Header: WithIcon("Image Browser", faImages),
            accessor: "context",
            sortable: false,
            width: 40,
            Cell: (row) => {
                return (
                    <Link
                        className="flex align-items-center"
                        target="_blank"
                        rel="noopener noreferrer"
                        to={`/image-browser/${row.original.context.shipmentKey}/${row.original.context.shipmentProductKey}`}
                    >
                        <FontAwesomeIcon icon={faImages} />
                    </Link>
                );
            },
        },
        {
            Header: WithIcon("Notes", faStickyNote),
            accessor: "note",
            sortable: false,
            Cell: (row) => {
                const fullUpc = row.original.context.productModifier
                    ? `${row.original.context.upc}-${row.original.context.productModifier}`
                    : row.original.context.upc;

                return (
                    <div
                        className="measuring-notes-btn"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <MeasuringNoteButton
                            upc={fullUpc}
                            settings={{
                                shipmentKey: shipmentKey,
                                shipmentProductKey: row.original.context.shipmentProductKey,
                            }}
                            clientCode={row.original.context.cxHClientCode}
                            binTrackingNumber={[row.original.context.binTrackingNumber]}
                            hasNotes={row.original.hasComments}
                        />
                    </div>
                );
            },
            filterable: false,
            width: 40,
        },
    ];
};
